module.exports = {"welcome":"Welcome <strong>%{name}</strong>","options":"User Actions","logout":"Log out"}